import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode } from '@fortawesome/free-solid-svg-icons';

import { green } from '~theme';

import QRCodeReader from '~components/form/QRCodeReader';

const QRCodeSelection = ({ options }) => {
  return (
    <Wrapper>
      <Title>
        <FontAwesomeIcon
          icon={faQrcode}
          style={{ fontSize: 24, marginRight: 8 }}
        />
        Lue QR-koodi
      </Title>
      {options.map(option => (
        <QRCodeReader
          key={option.label}
          fat
          bgColor={green}
          label={option.label}
          onRead={option.onRead}
        />
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 20px;
`;

const Title = styled.h2`
  font-size: 20px;
  margin-top: 5px;
  margin-bottom: 50px;
  display: flex;
  align-items: center;
  color: ${green};
`;

export default QRCodeSelection;
